import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MitidIcon = function MitidIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: "48",
      height: "48",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.5714 14.3077H30.009C38.4331 14.3077 42 18.6819 42 24.1538C42 29.6258 38.4331 34 30.009 34H26.5714V14.3077ZM24.0001 34H6C6.5131 27.9276 10.3191 25.3846 15 25.3846C19.681 25.3846 23.487 27.9276 24.0001 34ZM19.9822 18.7692C19.9822 21.4033 17.7515 23.5385 15 23.5385C12.2484 23.5385 10.0179 21.4033 10.0179 18.7692C10.0179 16.1353 12.2484 14 15 14C17.7515 14 19.9822 16.1353 19.9822 18.7692Z",
      fill: "#0060E6"
    })]
  }));
};
export default MitidIcon;